// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "mobile" + "." + "1d63ae3a" + ".1786933990632.css";
};